import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import 'animate.css'
import '@sakun/system.css'
import { createPinia } from 'pinia'
import piniaPersist from 'pinia-plugin-persist'

const pinia = createPinia()
pinia.use(piniaPersist)

createApp(App).use(pinia).mount('#app')
